<template>
	<b-navbar toggleable="lg" class="os-navbar">
		<b-nav-item class="d-block d-xl-none">
			<router-link to="/inicio-sesion">
				<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/profile.svg" color="#3238C4" style="height: 2.5rem; width: 2.5rem;"/>
			</router-link>
		</b-nav-item>  
		<b-navbar-brand href="/" class="mx-auto mx-xl-0">
			<img src="/static-appopensalud/img/logos/RGB_OPENSALUD_AZUL.svg" alt="opensalud" class="navbar-brand-img"/>
		</b-navbar-brand>
		<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
		<b-collapse id="nav-collapse" is-nav>
			<b-navbar-nav class="os-navbar-dropdown ml-xl-auto">
				<b-nav-item href="#">Link</b-nav-item>
				<b-nav-item href="#" disabled>Disabled</b-nav-item>
			</b-navbar-nav>
		</b-collapse>
	</b-navbar>
</template>

<script>
import { BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle, BCollapse, BNavItem, BNavForm, BFormInput, BButton, BNavItemDropdown, BDropdownItem } from 'bootstrap-vue'

export default {
	name: 'BasePublicNavbar',
	components: {
		BNavbar,
		BNavbarNav,
		BNavbarBrand,
		BNavbarToggle,
		BCollapse,
		BNavItem,
		BNavForm,
		BFormInput,
		BButton,
		BNavItemDropdown,
		BDropdownItem
	}
}
</script>

<style lang="scss" scoped>
	.os-navbar {
		@include container-padding;
		width: 100%;
		@include media(tablets, mobile) {
			position: fixed;
		}
	}
	.navbar-brand-img {
		width: 130px;

		@include tablets {
			width: 150px;
		}
	}

	.os-profile-btn {
		background-color: transparent;
		border: none;
	}

	.os-navbar-dropdown {
		@include media(tablets, mobile) {
			text-align: center;
			width: fit-content;
			margin-left: auto;
			background-color: $white;
			border-radius: $border-radius;
			box-shadow: $custom-shadow-bottom;
			padding: 1rem 1.5rem;
			margin-top: 1rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/base/ui/BasePublicNavbar.vue